import { render } from "./LastMatchHome.vue?vue&type=template&id=4e9dbff0&scoped=true"
import script from "./LastMatchHome.vue?vue&type=script&lang=js"
export * from "./LastMatchHome.vue?vue&type=script&lang=js"

import "./LastMatchHome.vue?vue&type=style&index=0&id=4e9dbff0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9dbff0"]])

export default __exports__